import { useContext, useEffect, useState } from "react";
import { MdClose, MdOutlineSchema } from "react-icons/md";
import LoadingCircle from "../../utility/LoadingCircle";
import UserContext from "../../User/UserContext";

const SectionInfoModal = ({
	sectionName,
	setShowSectionInfoModal,
	condition_type,
	condition_value,
	field_condition_id,
	section_condition_id,
	sections,
}) => {
	const { api, token } = useContext(UserContext);
	const [conditionalFieldName, setConditionalFieldName] = useState("");
	const [conditionalSectionName, setConditionalSectionName] = useState("");
	const [fields, setFields] = useState([]);
	const [checkingFields, setCheckingFields] = useState(true);
	const [checkingSections, setCheckingSections] = useState(true);

	useEffect(() => {
		if (!api || !token || section_condition_id === "" || section_condition_id === 0 || typeof section_condition_id === "undefined") {
			return;
		}
		const controller = new AbortController();
		const signal = controller.signal;
		fetch(api + "/section/" + section_condition_id, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
			signal,
		})
			.then((res) => {
				if (!res.ok) {
				} else {
					return res.json();
				}
			})
			.then((res) => {
				if (res) {
					setFields(res.fields);
				}
			})
			.catch((err) => {});

		return () => {
			controller.abort();
		};
	}, [api, token, section_condition_id]);

	useEffect(() => {
		findConditionalSectionName(section_condition_id, sections);
	}, [section_condition_id, sections]);

	const findConditionalSectionName = (sectionId, theSections) => {
		for (let i = 0; i < theSections.length; i++) {
			if (String(theSections[i].id) === String(sectionId)) {
				setCheckingSections(false);
				setConditionalSectionName(theSections[i].name);
				return;
			}
		}
		setCheckingSections(false);
		setConditionalSectionName("");
	};

	useEffect(() => {
		if (fields.length === 0) {
			if (isNaN(field_condition_id) || field_condition_id === 0) {
				setCheckingFields(false);
			}
			return;
		}
		findConditionalFieldName(field_condition_id, fields);
	}, [field_condition_id, fields]);

	const findConditionalFieldName = (fieldId, theFields) => {
		for (let i = 0; i < theFields.length; i++) {
			if (String(theFields[i].id) === String(fieldId)) {
				setCheckingFields(false);
				setConditionalFieldName(theFields[i].name);
				return;
			}
		}
		setCheckingFields(false);
		setConditionalFieldName("");
	};

	const isLoading = checkingFields || checkingSections;
	const hasCondition = conditionalSectionName !== "" && conditionalFieldName !== "";

	return (
		<div
			className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black/50 z-50"
			onClick={() => setShowSectionInfoModal(false)}>
			<div className="bg-white w-full max-w-lg m-2 rounded-lg border border-black shadow-lg" onClick={(e) => e.stopPropagation()}>
				<div className="p-4 text-left font-bold text-2xl flex justify-between items-center gap-3 bg-gray-300 rounded-t-lg">
					<div className="flex items-center gap-2 min-w-0">
						<MdOutlineSchema className="shrink-0" />
						<span className="truncate">{sectionName}</span>
					</div>
					<MdClose color="red" className="text-3xl cursor-pointer shrink-0" onClick={() => setShowSectionInfoModal(false)} />
				</div>
				<div className="p-5">
					<p className="text-sm uppercase tracking-wide text-gray-500 mb-3">Display condition</p>
					{isLoading ? (
						<div className="flex flex-col items-center justify-center py-8 gap-2">
							<LoadingCircle />
							<p className="text-gray-600">Loading condition…</p>
						</div>
					) : !hasCondition ? (
						<div className="rounded-md border border-dashed border-gray-300 bg-gray-50 p-4 text-gray-600">
							This section doesn’t have a condition.
						</div>
					) : (
						<div className="rounded-md border border-gray-300 bg-gray-50 p-4 space-y-3">
							<p className="text-gray-800">
								This section displays when the following is true:
							</p>
							<div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2 items-baseline">
								<span className="text-sm font-semibold text-gray-500">Section</span>
								<span className="font-medium text-gray-900">{conditionalSectionName}</span>
								<span className="text-sm font-semibold text-gray-500">Field</span>
								<span className="font-medium text-gray-900">{conditionalFieldName}</span>
								<span className="text-sm font-semibold text-gray-500">Rule</span>
								<span className="font-medium text-gray-900">
									<span className="inline-block rounded bg-white border border-gray-300 px-2 py-0.5 font-mono text-sm mr-2">
										{condition_type}
									</span>
									<span className="inline-block rounded bg-white border border-gray-300 px-2 py-0.5 font-mono text-sm">
										{condition_value}
									</span>
								</span>
							</div>
							<p className="text-sm text-gray-600 pt-1 border-t border-gray-200">
								Shows when <span className="font-medium text-gray-800">{conditionalFieldName}</span> in{" "}
								<span className="font-medium text-gray-800">{conditionalSectionName}</span> is{" "}
								<span className="font-mono">{condition_type}</span>{" "}
								<span className="font-mono">{condition_value}</span>
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SectionInfoModal;
